import logo from "../../assets/images/logo3.png";
import email from "../../assets/icons/email.svg";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__container-top">
          <img src={logo} alt="Eureka Logo" className="footer__logo" />
          <p className="footer__text">Your Analytics Companion for Reddit</p>
        </div>
        <span className="footer__line"></span>
        <p className="footer__text">Get in Touch</p>
        <div className="footer__container-bottom">
          <a href="mailto: eureka.inquiry@gmail.com" className="footer__link">
            <img
              src={email}
              alt="Email icon"
              className="footer__img footer__img--large"
            />
          </a>
        </div>
        <p className="footer__text-copy">
          Copyright © {new Date().getFullYear()} Eureka
        </p>
      </div>
    </footer>
  );
};

export default Footer;
